import {
  combineReducers,
  configureStore,
} from '@reduxjs/toolkit';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import {authApi} from './api/authApi';
import {courseApi} from './api/courseApi';
import {tutorApi} from './api/tutorApi';
import {studentApi} from './api/studentApi';
import {masterApi} from './api/masterApi';
import {searchApi} from './api/searchApi';
import tutorReducer from './slices/tutorSlice';
import studentReducer from './slices/studentSlice';
import authReducer from './slices/authSlice';
import courseReducer from './slices/courseSlice';
import masterReducer from './slices/masterSlice';
import searchReducer from './slices/searchSlice';
import { errorMiddleware } from './middleware/errorMiddleware';

const reducers = combineReducers({
  [authApi.reducerPath]: authApi.reducer,
  [courseApi.reducerPath]: courseApi.reducer,
  [tutorApi.reducerPath]: tutorApi.reducer,
  [studentApi.reducerPath]: studentApi.reducer,
  [masterApi.reducerPath]: masterApi.reducer,
  [searchApi.reducerPath]: searchApi.reducer,
  tutor: tutorReducer,
  student: studentReducer,
  auth: authReducer,
  course: courseReducer,
  master: masterReducer,
  search: searchReducer,
});

const persistConfig = {
  key: 'root',
  storage: storage,
  whitelist: ['auth', 'master', 'search'],
};

const persistedReducer = persistReducer(persistConfig, reducers);

// const getEnhancers = (
//   getDefaultEnhancers: (options?: EnhancerOptions) => any,
// ) => {
//   if (process.env.NODE_ENV === 'development') {
//     const reactotron = require('../../ReactotronConfig').default;
//     return getDefaultEnhancers().concat(reactotron.createEnhancer());
//   }
//   return getDefaultEnhancers();
// };

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(
      authApi.middleware,
      courseApi.middleware,
      tutorApi.middleware,
      studentApi.middleware,
      masterApi.middleware,
      searchApi.middleware,
      errorMiddleware as any,
    ),
  //enhancers: getEnhancers,
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
